module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [_c('span', {
    staticClass: "header_title"
  }, [_vm._v("合同详情")]), _vm._v(" "), _c('svg', {
    staticClass: "arrow_down",
    attrs: {
      "width": "6.5vw",
      "height": "6.5vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('toggleShow')
      }
    }
  }, [_c('path', {
    attrs: {
      "d": "M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z",
      "fill": "#ffffff"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [(_vm.contractInfo) ? _c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("合同名称")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.contractName))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("合同编号")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.contractNo))])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("线下合同编号")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.contractNoOffline))])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("合同金额")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("¥" + _vm._s(_vm.splitMoney(_vm.contractInfo.contractMoney)))])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("付款方式")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.payTypeString))])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), (_vm.type === '交付' && _vm.selected === '累计') ? _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("合同是否结清账款")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.isSettledString))])]), _vm._v(" "), _vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.type === '交付' && _vm.selected === '累计') ? _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("未结清账款金额")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("¥" + _vm._s(_vm.contractInfo.notSettledMoneySum && _vm.splitMoney(_vm.contractInfo.notSettledMoneySum.toFixed(2))))])]), _vm._v(" "), _vm._m(6)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("业务员")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.employeeName))])]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("签署客户名称")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.signedCustomerName))])]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("签署客户单位")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.signedEnterpriseName))])]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("合同启动日期")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.contractStartDT))])]), _vm._v(" "), _vm._m(10)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("生产状态")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.produceStatusString))])]), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("预计生产完结日期")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.expectedProduceEndDT))])]), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("发货状态")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.deliveryStatusString))])]), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("发货日期")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.contractInfo.deliveryDT))])]), _vm._v(" "), _vm._m(14)]), _vm._v(" "), (_vm.type === '消费') ? _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("待收账户余额")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("¥" + _vm._s(_vm.contractInfo.waitPrepayAmount && _vm.splitMoney(_vm.contractInfo.waitPrepayAmount.toFixed(2))))])]), _vm._v(" "), _vm._m(15)]) : _vm._e(), _vm._v(" "), (_vm.type === '交付') ? _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("待收尾款")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v("¥" + _vm._s(_vm.contractInfo.waitRetainage && _vm.splitMoney(_vm.contractInfo.waitRetainage.toFixed(2))))])]), _vm._v(" "), _vm._m(16)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10vw"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-552c9650","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchGroupBill/BillDetail.vue
// module id = 1638
// module chunks = 8